import React from "react"
import Label from './Label';

/*
form input type text, stile toggle bs4
riceve:
name: nome del campo attr name
value: valore del campo
label: etichetta
onChange: f. evento al cambiamento
redflag: boolean evidenziazione rossa
btns: bottoni opzionali
*/
function InputField(props) {

    //{ name, value, label, onChange, redflag = false, type = "text", btns = [], readOnly = false }

    //uso btns, redflag,onchange,label. Tutto il resto (value, name, + opzionali type, maxlength,readonly..) va su input
    const { btns, redflag, onChange, labelprops = {}, label, noRounded = false, ...ps } = { ...props };
    //a input aggiunto classname
    const myClassName = "form-control form-control-sm " + (redflag ? " is-invalid" : "") + (!noRounded ? " rounded rotondo" : "");
    ps.className = ps.className ? ps.className + " " + myClassName : myClassName;
    const input = (<input
        {...ps}
        autoComplete="off"
        onChange={e => onChange({ value: e.target.value })}
    />);

    const inputGroup = !btns || btns.length === 0 ? input :
        (<div className={"input-group input-group-sm" + (redflag ? " is-invalid" : "")}>
            {input}
            {btns.map((v, k) => <div key={k} className="input-group-append">{v}</div>)}
        </div>)

    const { className = '', ...mylabelprops } = { ...labelprops };
    const css = className.split(' ');
    css.push('form-control-label');
    return (
        <>
            <Label  {...mylabelprops} required={props.required} className={css.join(' ')} htmlFor={props.name}>{label}</Label>
            {inputGroup}
        </>
    );
}
export default InputField;